import React from 'react';
import { Box, Button } from '@mui/material';

interface Props {
    previewFile: { url: string; type: string } | null;
    onClose: () => void;
}

const PreviewModal: React.FC<Props> = ({ previewFile, onClose }) => {
    if (!previewFile) return null;

    return (
        <Box
            position="fixed"
            top="50%"
            left="50%"
            zIndex={9999}
            sx={{
                transform: 'translate(-50%, -50%)',
                bgcolor: 'white',
                boxShadow: 24,
                p: 2,
                borderRadius: 2,
                maxWidth: '90vw',
                maxHeight: '90vh',
            }}
        >
            {previewFile.type.startsWith("image/") ? (
                <img src={previewFile.url} alt="Vista previa" style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: 8 }} />
            ) : (
                <iframe src={previewFile.url} title="Vista previa PDF" style={{ width: '80vw', height: '80vh', border: 'none' }} />
            )}
            <Box textAlign="center" mt={2}>
                <Button variant="outlined" onClick={onClose} color="secondary">
                    Cerrar
                </Button>
            </Box>
        </Box>
    );
};

export default PreviewModal;
